<template>
  <div class="curriculum">
    <div class="certi_logo">
      <div>
        <img src="../assets/img/logo02.png" alt="" />
      </div>
    </div>
    <div class="curriculum_box">
      <h2>安徽省专业技术人员继续教育培训 证 书 查 询</h2>
      <div class="curriculum_tab">
        <table>
          <tr>
            <!-- <th>序号</th> -->
            <th>姓名</th>
            <th>单位</th>
            <th>身份证号</th>
            <th>学习课程</th>
            <th>证书编号</th>
          </tr>
          <tr v-for="(item, index) in list" :key="index">
            <!-- <td>{{ item.id }}</td> -->
            <td>{{ item.full_name }}</td>
            <td>{{ item.company }}</td>
            <td>{{ item.id_card }}</td>
            <td>{{ item.learning_courses }}</td>
            <td>{{ item.certificate_no }}</td>
          </tr>
        </table>

        <div :class="[{ hide: isPageHide }]">
          <br>
          <el-pagination
            style="text-align: center"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :currentPage="currentPage"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>

      </div>

    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "./Footer";
export default {
  props: {},
  data() {
    return {
      list: [],
      currentPage: 1,
      pageSize: 15,
      total: 0,
      isPageHide: 0,
      idnumber: 0,
      certnumber: 0,
    };
  },
  computed: {},
  created() {},
  mounted() {
    var query=this.$route.query;
    this.idnumber = query.idnumber;
    this.certnumber = query.certnumber;
    this.getList(this.idnumber, this.certnumber, 1);
  },
  watch: {},
  methods: {

    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList(this.idnumber, this.certnumber, val);
    },
    getList(card,no,pageid) {
      let _this = this;
      _this.request("api/course/list", {card:card, no:no, page: pageid }, "get").then((res) => {
        if (res.data.status == "success") {
          _this.list = res.data.data.data;
          _this.currentPage = res.data.data.current_page;
          _this.total = res.data.data.total;
          _this.pageSize = res.data.data.per_page;
          if (res.data.data.data.length==0) {
            _this.isPageHide = 1;
          }
        }
      });
    },

  },
  components: { Footer },
};
</script>

<style lang="less" scoped>
.curriculum {
  .certi_logo {
    width: 100%;
    height: 2.38rem;
    background-color: #666666;
    div {
      width: 3.81rem;
      height: 1.35rem;
      img {
        width: 100%;
        margin-top: 0.5rem;
        margin-left: 1.76rem;
      }
    }
  }
  .curriculum_box {
    h2 {
      font-size: 0.58rem;
      text-align: center;
      padding-top: 2rem;
    }
    .curriculum_tab {
      margin-bottom: 2rem;
      table {
        margin: 0 auto;
        padding-top: 0.8rem;
        tr {
          th {
            background-color: #bfbfbf;
            color: #fff;
            font-size: 0.27rem;
            padding: 0.1rem 0.2rem;
          }

          td {
            padding: 0.2rem 0.2rem;
            font-size: 0.27rem;
            border-bottom: 2px solid #bfbfbf;
          }
          td:nth-of-type(1) {
            text-align: center;
          }
        }
      }
    }
  }
}
.hide{display: none}
</style>
